import {
    FETCH_INHOUSE_PALLET_DETAIL, FETCH_INHOUSE_PALLETIZATION_TABLE_DATA, FETCH_ERROR,
    FETCH_SUCCESS, FETCH_START, FETCH_RM_STOCK_STATUS_COUNT, FETCH_INHOUSE_PALLET_PICKING_READY,
    FETCH_RM_STOCK_DETAIL,FETCH_QUALITYCHECK_CARD_COUNT,FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT,
    FETCH_RM_STOCK_TABLE_DATA, FETCH_SERRICO_MAPPED_DATA
} from "../types"
import axios from "../../services/Api";
import { showToast } from "../../services/functions";



export const getQualityControlCardWiseCount = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/job/getQAJobStatusCount', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_QUALITYCHECK_CARD_COUNT, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_QUALITYCHECK_CARD_COUNT, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const jobRequestApproval = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('job/jobRequestApproval', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });

            showToast(error.message, true);
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const jobAwaitingApproval = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('job/jobAwaitingApproval', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });

            showToast(error.message, true);
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};



export const saveRawMaterialStock = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/saveRawStock', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            callback(null)
        });
    }
};

export const getRawMaterialStockTableData = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/getRawStockList', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_RM_STOCK_TABLE_DATA, payload: { data: data?.data || [], count: data?.count,allLabelOptions:data?.allLabelOptions || []  } })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_RM_STOCK_TABLE_DATA, payload: { data: [], count: 0,allLabelOptions:[] } })
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            const errorObj = {
                success: false,
                message: error?.message,
                status: error?.response?.status,
                code: error?.code,
                isGatewayTimeout:
                    error?.response?.status === 504 ||
                    error?.code === "ECONNABORTED" ||
                    error?.code === "ERR_NETWORK" ||
                    !error?.response,
                error,
            };
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb(errorObj)
            }
        });
    }
};

export const getRawMaterialStocktDetail = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/getRawStockDetails', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_RM_STOCK_DETAIL, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_RM_STOCK_DETAIL, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const updateRawMaterialStock = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/updateRawStock', payload).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
            }
            callback(data);
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            callback({success:false,message:error.message});
        });
    }
};

export const getRawMaterialStatusWiseCount = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/getRawStockStatusWiseCount', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_RM_STOCK_STATUS_COUNT, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_RM_STOCK_STATUS_COUNT, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const saveRMStockBulkUpload = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/bulkUploadRawStock', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            showToast(error.message, true);
            callback(null)
        });
    }
};

export const approveRejectRMStockStatus = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/updateRawStockStatus', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });

            showToast(error.message, true);
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const getHygieneMaterialCardTypeWiseCount = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/getMaterialTypeWiseCount', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};


export const saveMappedHygieneMaterial = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/mapSerricoTrapToGrid', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });

            showToast(error.message, true);
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const saveHygieneMaterialBulkUpload = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/bulkSerricoTrapToGridMapping', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            showToast(error.message, true);
            callback(null)
        });
    }
};


export const getweeklyBeetlesData = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/getweeklyBeetlesData', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_SERRICO_MAPPED_DATA, payload: { data: data?.data || [], count: data?.count } })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_SERRICO_MAPPED_DATA, payload: { data: [], count: 0 } })
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const replaceExpiredSerricoTrap = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/replaceSerricoTrap', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });

            showToast(error.message, true);
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};


export const bulkReplaceExpiredSerricoTrap = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/inventory/bulkReplaceSerricoTrap', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            showToast(error.message, true);
            callback(null)
        });
    }
};
